<div class="main-content-wrapper">
  <div class="section mt-2 d-flex justify-content-between align-items-center">
    <div class="first-section">
      <h5>Add New Price Configs</h5>
    </div>
  </div>
  <section class="intro">
    <div class="mask d-flex align-items-center">
      <div class="container-fluid d-block d-flex justify-content-between">
        <div class="row tbl justify-content-center">
          <div class="col-12 intro">
            <div class="table-responsive table-container">
              <table class="table category-table table-condensed mb-0">
                <thead class="sticky-top">
                  <tr>
                    <th scope="col" style="align-items: center">Store Group</th>
                    <th scope="col">Department</th>
                    <th scope="col">Pricing Type</th>
                    <th scope="col">Status</th>
                    <th scope="col" style="text-align: center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of receivedData">
                    <td>
                      <span>{{ data.storeGroupName }}</span>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span>{{ data.departmentDescr }}</span>
                        <span>{{ data.department }}</span>
                      </div>
                    </td>
                    <td>
                      <select class="form-select" aria-label="Default select example" [(ngModel)]="data.pricingTypeID"
                        (change)="getStatus(data)">
                        <option [value]="0" [hidden]="data.pricingTypeID && data.pricingTypeID != 0">Select Pricing Type
                        </option>
                        <option *ngFor="let pricetype of pricingType" [value]="pricetype.pricingTypeId">
                          {{ pricetype.pricingDescr }}
                        </option>
                      </select>
                    </td>
                    <td class="d-flex gx-3 flex-col" style="
                        align-items: center;
                        gap: 5px;
                        flex-direction: column;
                        align-items: baseline;
                      ">
                      {{ data.status }}
                      <div class="progress" style="display: flex; width: 100%; height: 8px" *ngIf="data.status">
                        <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="data.percentage"
                          aria-valuemin="0" aria-valuemax="100" [style.width.%]="data.percentage" [ngClass]="{
                            orange: data.percentage <= 99,
                            lightgreen: data.percentage >= 100
                          }"></div>
                      </div>
                    </td>
                    <td style="text-align: center">
                      <div class="btn-group dropleft">
                        <button type="button" class="action-drop" (click)="handlePricingConfigClick(data)">
                          <i><img class="svg-icon" style="width: 25px" src="../../../assets/icons/dollor.png" /></i>
                        </button>
                        <button type="button" class="action-drop ms-2" (click)="deletePricingDept(data)">
                          <i><img style="width: 25px" src="../../../assets/Pricingscreen/delete.svg" /></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!--  <button class="btn" style="color: #A6E301; font-weight: 600;" data-bs-target="#addPriceConfig" data-bs-toggle="modal">Add Department</button>-->
              <div class="footer-wrapper mt-3 ms-2">
                <button class="btn modal-btn" style="background-color: #0070b9; color: white"
                  routerLink="/admin/home/pricing/pricing-config">
                  Finish
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<!--Boostrap modal for set price to department/categories-->
<div #setPriceConfigModal class="modal fade" id="setPriceConfigModal" data-bs-backdrop="static" data-bs-keyboard="false"
  aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0" style="margin-left: 1rem">
          {{ storeGroupName }} | {{ departmentName }} | {{ pricingTypeName }}
        </h5>
      </div>
      <div class="modal-body">
        <div class="d-flex gap-x-3" *ngIf="
            !(pricingTypeID === 3 || pricingTypeID === 5 || pricingTypeID === 6)
          ">
          <div class="custom-select">
            <div id="selectField" [hidden]="categoryList.length == 0" (click)="showSelect(0)">
              <span id="selectedText">{{ selectedVal }}</span>
              <img class="img-fluid" width="14" src="../../../assets/Pricingscreen/arrow-down.svg" />
            </div>
            <ul class="select-body" [hidden]="showCustomSelect || categoryList.length === 0">
              <li class="options" *ngFor="let data of categoryList">
                <div (click)="getSelect(data.categoryName, data.categoryId, 0)">
                  <img class="img-fluid" style="width: 15px" [src]="data.image" alt="icon" />
                  <p>{{ data.categoryName }}</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="custom-select1">
            <div id="selectField" [hidden]="categoryList.length === 0" [style.backgroundColor]="
                selectedCategoryID == 0 || subCategoryList1.length == 0
                  ? '#eee'
                  : 'transparent'
              " (click)="showSelect(1)">
              <span id="selectedText">{{ selectedVal1 }} </span>
              <img class="img-fluid" width="14" src="../../../assets/Pricingscreen/arrow-down.svg" />
            </div>
            <ul class="select-body" [hidden]="
                showCustomSelect1 ||
                subCategoryList1.length === 0 ||
                selectedCategoryID == 0
              ">
              <li class="options" *ngFor="let data of subCategoryList1">
                <div (click)="getSelect(data.categoryName, data.subCategoryId, 1)">
                  <img class="img-fluid" style="width: 15px" [src]="data.image" alt="icon" />
                  <p>{{ data.categoryName }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="tbl-body">
          <div class="table-responsive mb-0">
            <table class="table mb-0">
              <thead class="sticky-top" style="background: white">
                <tr [hidden]="pricingTypeID != 1">
                  <th scope="col" style="padding-left: 2rem">Quality</th>
                  <th scope="col">Pricelist</th>
                </tr>
                <tr [hidden]="pricingTypeID != 2">
                  <th scope="col" style="padding-left: 2rem">Options</th>
                  <th scope="col">Pricelist</th>
                  <th scope="col"></th>
                </tr>
                <tr [hidden]="pricingTypeID != 3">
                  <th scope="col" style="padding-left: 2rem">Options</th>
                  <th scope="col">Pricelist</th>
                  <th scope="col"></th>
                </tr>
                <tr [hidden]="pricingTypeID != 4">
                  <th scope="col" style="padding-left: 2rem">Quality</th>
                  <th scope="col">Condition</th>
                  <th scope="col">Pricelist</th>
                </tr>
                <tr [hidden]="pricingTypeID != 5">
                  <th scope="col" style="padding-left: 2rem">Quality</th>
                  <th scope="col">Pricelist</th>
                </tr>
                <tr [hidden]="pricingTypeID != 6">
                  <th scope="col" style="padding-left: 2rem">Quality</th>
                  <th scope="col">Condition</th>
                  <th scope="col">Pricelist</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let price of pricingDataList" [hidden]="pricingTypeID != 1">
                  <td>
                    <span class="bgColor" [style.backgroundColor]="
                        price.QualityColor || price.qualityColor
                      ">
                      {{ price.qualitydescr }}{{ price.qualityDescr }}
                    </span>
                  </td>
                  <td>
                    <div class="enter-price" [style.backgroundColor]="
                        this.subCategoryList1.length != 0 &&
                        this.selectedSubCategoryID == 0
                          ? '#eee'
                          : 'transparent'
                      ">
                      $&nbsp;
                      <input type="text" placeholder="Enter Value" [disabled]="
                          isPricePresent ||
                          (this.subCategoryList1.length != 0 &&
                            this.selectedSubCategoryID == 0)
                        " [(ngModel)]="price.price" appTwoDigitDecimaNumber />
                    </div>
                  </td>
                </tr>
                <tr *ngFor="let price of pricingDataList; index as i" [hidden]="pricingTypeID != 2">
                  <td style="padding-left: 2rem">Price {{ i + 1 }}</td>
                  <td>
                    <div class="enter-price" [style.backgroundColor]="
                        this.subCategoryList1.length != 0 &&
                        this.selectedSubCategoryID == 0
                          ? '#eee'
                          : 'transparent'
                      ">
                      $&nbsp;
                      <input type="text" placeholder="Enter Value" [disabled]="
                          isPricePresent ||
                          (this.subCategoryList1.length != 0 &&
                            this.selectedSubCategoryID == 0)
                        " [(ngModel)]="price.price" appTwoDigitDecimaNumber />
                    </div>
                  </td>
                  <td>
                    <button _ngcontent-ng-cli-universal-c108="" type="button" class="action-drop ms-2"
                      (click)="delLevel(i, price)">
                      <i _ngcontent-ng-cli-universal-c108="">
                        <img _ngcontent-ng-cli-universal-c108="" src="../../../assets/Pricingscreen/delete.svg"
                          style="width: 25px" />
                      </i>
                    </button>
                  </td>
                </tr>
                <tr *ngFor="let price of pricingDataList; index as i" [hidden]="pricingTypeID != 3">
                  <td style="padding-left: 2rem">Price {{ i + 1 }}</td>
                  <td>
                    <div class="enter-price">
                      $&nbsp;
                      <input type="text" placeholder="Enter Values" [(ngModel)]="price.price" appTwoDigitDecimaNumber />
                    </div>
                  </td>
                  <td>
                    <button _ngcontent-ng-cli-universal-c108="" type="button" class="action-drop ms-2"
                      (click)="delLevel(i, price)">
                      <i _ngcontent-ng-cli-universal-c108="">
                        <img _ngcontent-ng-cli-universal-c108="" src="../../../assets/Pricingscreen/delete.svg"
                          style="width: 25px" />
                      </i>
                    </button>
                  </td>
                </tr>
                <tr *ngFor="let price of pricingDataList" [hidden]="pricingTypeID != 4" style="overflow: scroll">
                  <td>
                    <span class="bgColor" [style.backgroundColor]="
                        price.QualityColor || price.qualityColor
                      ">
                      {{ price.qualityDescr }}
                      {{ price.QualityDescr }}
                      {{ price.qualitydescr }}
                    </span>
                  </td>
                  <td>
                    <div>
                      <span class="condColor" [style.borderColor]="
                          price.ConditionColor || price.conditionColor
                        ">
                        {{ price.ConditionDescr }}
                        {{ price.conditionDescr }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="enter-price" [style.backgroundColor]="
                        this.subCategoryList1.length != 0 &&
                        this.selectedSubCategoryID == 0
                          ? '#eee'
                          : 'transparent'
                      ">
                      $&nbsp;
                      <input type="text" placeholder="Enter Value" [disabled]="
                          isPricePresent ||
                          (this.subCategoryList1.length != 0 &&
                            this.selectedSubCategoryID == 0)
                        " [(ngModel)]="price.price" appTwoDigitDecimaNumber />
                    </div>
                  </td>
                </tr>
                <tr *ngFor="let price of pricingDataList" [hidden]="pricingTypeID != 5">
                  <td>
                    <span class="bgColor" [style.backgroundColor]="
                        price.QualityColor || price.qualityColor
                      ">
                      {{ price.qualityDescr }}
                      {{ price.QualityDescr }}
                      {{ price.qualitydescr }}
                    </span>
                  </td>
                  <td>
                    <div class="enter-price">
                      $&nbsp;
                      <input type="text" placeholder="Enter Value" [disabled]="isPricePresent" [(ngModel)]="price.price"
                        appTwoDigitDecimaNumber />
                    </div>
                  </td>
                </tr>
                <tr *ngFor="let price of pricingDataList; &quot;inpt-Box&quot;" [hidden]="pricingTypeID != 6">
                  <td>
                    <span class="bgColor" [style.backgroundColor]="
                        price.QualityColor || price.qualityColor
                      ">
                      {{ price.qualityDescr }}
                      {{ price.QualityDescr }}
                      {{ price.qualitydescr }}
                    </span>
                  </td>
                  <td>
                    <span class="condColor" [style.borderColor]="
                        price.ConditionColor || price.conditionColor
                      ">
                      {{ price.ConditionDescr }}
                      {{ price.conditionDescr }}
                    </span>
                  </td>
                  <td>
                    <div class="enter-price">
                      $&nbsp;
                      <input type="text" placeholder="Enter Value" [disabled]="isPricePresent" [(ngModel)]="price.price"
                        appTwoDigitDecimaNumber />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <button class="btn modal-btn add-btn ms-2 add-level-btn" [hidden]="pricingTypeID != 3 && pricingTypeID != 2"
              (click)="addLevel()">
              + Add Level
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <button id="closeBtns" class="btn modal-btn me-2" data-bs-dismiss="modal" aria-label="Close"
          style="background-color: #ffffff; color: #0070b9" (click)="clearData()">
          Close
        </button>
        <button class="btn modal-btn add-btn ms-2" (click)="postPricingData(price)" data-bs-dismiss="modal"
          [disabled]="disablePost" aria-label="Close" routerLink="/admin/home/pricing/add-pricing"
          *ngIf="!buttonDisabled">
          Add Price
        </button>
        <button class="disable-btn ms-2" *ngIf="buttonDisabled">
          Add Price
        </button>
      </div>
    </div>
  </div>
</div>

<!--Boostrap modal for add price config-->
<div class="modal fade" id="addPriceConfig" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Add New Price Config</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="d-flex align-items-center mb-2">
          <h6 class="head">Select Store Group</h6>
          &nbsp;
          <span class="d-block" style="color: #929292; font-size: 12px">(Select any one)</span>
        </div>
        <h6 class="head mb-2">Select Department</h6>
        <div class="row mt-2" style="
            overflow: auto;
            height: 335px;
            scrollbar-width: none;
            height: 245px;
          ">
          <div class="col-sm-2" *ngFor="let dept of departmentslist">
            <div class="col-wrapper getdept" [class.active]="dept.active"
              (click)="getSelectedDepartment(dept.departmentId)">
              <img [src]="dept.imageIcon" />
              <span class="d-block"> {{ dept.departmentDescr }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button class="btn modal-btn me-2" data-bs-dismiss="modal" aria-label="Close"
            style="background-color: #ffffff; color: #0070b9">
            Cancel
          </button>
          <button class="btn modal-btn ms-2" data-bs-dismiss="modal" aria-label="Close"
            style="background-color: #0070b9" routerLink="/admin/home/pricing/add-pricing">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Btn for open modal-->
<button style="display: none" #checkBtn data-bs-toggle="modal" href="#checkPrice">
  btn
</button>
<!--Bostrap Modal for Delete Confirmation -->
<!-- Bostrap Modal for Delete Confirmation -->
<div class="modal fade" id="checkPrice" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
  <div class="custom-modal-dialog modal-dialog modal-dialog-centered" style="max-width: 40%">
    <div class="modal-content">
      <div class="custom-modal-header modal-header">
        <h5 class="modal-title" id="exampleModalToggleLabel">
          Change Pricing Type
        </h5>
      </div>

      <div class="custom-modal-body modal-body" style="padding: 1.3rem 1.8rem 0.5rem 1.9rem">
        <div class="modal-body-wraapper">
          <p>
            Are you sure you want to change the Pricing Type of
            <strong>{{ dept?.departmentDescr }}</strong> | <strong>{{ tempDescr }}</strong>
          </p>
          <b class="mt-2 d-block" style="color: #d61313;">
            Once changed, all the following prices will get erased:
          </b>

          <!-- Prices list -->
          <div
            style="
              max-height: 200px;
              overflow-y: auto;
              margin-top: 8px;
              border: 1px solid #f0c0c0;
              border-radius: 5px;
              background-color: #fff8f8;
            "
          >
            <table class="table table-sm mb-0" style="font-size: 13px">
              <thead style="position: sticky; top: 0; background-color: #fde8e8;">
                <tr>
                  <th style="padding: 6px 10px;">Category</th>
                  <th style="padding: 6px 10px;">Quality</th>
                  <th style="padding: 6px 10px;">Condition</th>
                  <th style="padding: 6px 10px; text-align: right;">Price</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let price of existingPrices">
                  <td style="padding: 5px 10px;">{{ price.categoryName || '—' }}</td>
                  <td style="padding: 5px 10px;">{{ price.qualityDescr || '—' }}</td>
                  <td style="padding: 5px 10px;">{{ price.conditionDescr || '—' }}</td>
                  <td style="padding: 5px 10px; text-align: right;">${{ price.price }}</td>
                </tr>
                <tr *ngIf="existingPrices?.length === 0">
                  <td colspan="4" style="text-align: center; color: #999; padding: 10px;">
                    No price records found.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="custom-modal-footer modal-footer">
        <button
          class="btn modal-btn"
          data-bs-target="#exampleModalToggle2"
          data-bs-toggle="modal"
          style="color: #0070b9; border-radius: 8px; padding: 18px 10px"
        >
          Cancel
        </button>
        <button
          class="btn modal-btn"
          data-bs-target="#exampleModalToggle2"
          data-bs-toggle="modal"
          style="background-color: #d61313; color: white; white-space: nowrap; padding: 18px 10px;"
          (click)="delDeptModal()"
        >
          <i style="margin-right: 5px">⚠️</i> Yes, Change
        </button>
      </div>
    </div>
  </div>
</div>